import TweenLite from "gsap";

export default () => {
  // const setMegaNavPadding = () => {
  //     const megaNavWrap = document.querySelectorAll('.mega_nav .nav_wrap');
  //     if (megaNavWrap.length > 0) {
  //         if (!megaNavWrap[0].closest('.touch')) {
  //             megaNavWrap.forEach((wrap, i) => {
  //                 wrap.style.paddingLeft = wrap.closest('.menu').firstElementChild.getBoundingClientRect().left + 'px';
  //             });
  //         }
  //     }
  // }
  // setMegaNavPadding()
  // window.addEventListener('resize', () => {
  //     setMegaNavPadding()
  // })
  changeHeightHeader();
  const submenuLinks = document.querySelectorAll(".sub_menu_link");
  const linksInSubmenu = document.querySelectorAll(".sub_menu .menu-item");
  const languageSwitchLinks = document.querySelectorAll(
    ".wpml-ls-legacy-dropdown-click a"
  );
  const bookingNav = document.querySelector(".booking-nav");
  if (submenuLinks.length > 0) {
    // submenuLinks.forEach((link, i) => {
    //     const header = link.closest('.site_header');
    //     const headerLinks = header.querySelectorAll('.main_navigation .menu .menu-item a');

    //     header.addEventListener('mouseenter', () => {
    //         header.style.backgroundColor = 'rgba(255, 255, 255, 0.97)';
    //         header.querySelector('.logo .icon').style.fill = '#000';
    //         bookingNav.classList.add('booking-nav--dark');
    //         languageSwitchLinks.forEach((switchLink, i) => {
    //             switchLink.style.color = '#000';
    //         });
    //         headerLinks.forEach((headerLink, i) => {
    //             headerLink.style.color = '#000';
    //             if (!headerLink.closest('.sub_menu')) {
    //                 headerLink.querySelector('.inner').style.opacity = '0.4';
    //             }
    //         });
    //     })

    //     header.addEventListener('mouseleave', () => {
    //         header.style.backgroundColor = '';
    //         header.querySelector('.logo .icon').style.fill = '';
    //         bookingNav.classList.remove('booking-nav--dark');
    //         languageSwitchLinks.forEach((switchLink, i) => {
    //             switchLink.style.color = '';
    //         });
    //         headerLinks.forEach((headerLink, i) => {
    //             headerLink.style.color = '';
    //             headerLink.querySelector('.inner').style.opacity = '';
    //         });
    //     })
    // });

    linksInSubmenu.forEach((link, i) => {
      link.addEventListener("mouseenter", () => {
        linksInSubmenu.forEach((innerLink, i) => {
          if (innerLink != link) {
            innerLink.querySelector("a .inner").style.opacity = "0.4";
          }
        });
      });

      link.addEventListener("mouseleave", () => {
        linksInSubmenu.forEach((innerLink, i) => {
          innerLink.querySelector("a .inner").style.opacity = "";
        });
      });
    });
  }

  const bookingPhonesBtn = document.querySelectorAll(".booking-phones__btn");
  const header = document.querySelector(".site_header");
  if (bookingPhonesBtn.length > 0) {
    bookingPhonesBtn.forEach((btn, i) => {
      btn.addEventListener("click", () => {
        document.querySelector("body").classList.toggle("booking-nav--open");
        document.querySelector("body").classList.remove("language_switcher_open");
        header.classList.add("transparent-bg");
      });
    });
  }

  const bookingPhonesBg = document.querySelector(".blackout");
  if (bookingPhonesBg) {
    bookingPhonesBg.addEventListener("click", (e) => {
      if (!e.target.closest(".booking-phones__list")) {
        document.querySelector("body").classList.remove("booking-nav--open");
        header.classList.remove("transparent-bg");
      }
    });
  }

  const languageBtn = document.querySelector(".wpml-ls-item-toggle");

  languageBtn.addEventListener("click", () => {
    header.classList.toggle("transparent-bg");
  });

  const bookingPopupBtns = document.querySelectorAll(".booking-popup__btn");
  if (bookingPopupBtns.length > 0) {
    bookingPopupBtns.forEach((btn, i) => {
      btn.addEventListener("click", () => {
        document.querySelector("body").style.overflowY = "hidden";
        document
          .querySelector(".booking-popup")
          .classList.add("booking-popup--opened");
      });
    });
  }
  const bookingPopupBg = document.querySelector(".booking-popup");
  if (bookingPopupBg) {
    bookingPopupBg.addEventListener("click", (e) => {
      if (!e.target.closest(".booking-popup__item")) {
        document.querySelector("body").style.overflowY = "";
        document
          .querySelector(".booking-popup")
          .classList.remove("booking-popup--opened");
      }
    });
  }

  function changeHeightHeader() {
    const nonStickyHeader = document.querySelector(".non_sticky");

    const nonStickyMenu = nonStickyHeader.querySelector(".main_navigation");
    const nonStickyMenuItem = nonStickyMenu.querySelectorAll(".menu-item-type-post_type");

    const headerFixed = document.querySelector(".sticky_header");

    const menu = headerFixed.querySelector(".main_navigation");
    const menuItem = menu.querySelectorAll(".menu-item-type-post_type");
    const headerHeight = headerFixed.offsetHeight;
    const menuHeight = menu.offsetHeight;

    nonStickyMenuItem.forEach((item) => {
      const nonStickySubMenu = item.querySelector(".mega_nav");
      if (screen.width > 1200) {
        item.addEventListener("mouseenter", () => {
          if (item.contains(nonStickySubMenu)) {
            nonStickyHeader.style.height = headerHeight + 98 + "px";
          } 
        });
        item.addEventListener("mouseenter", () => {
          if (!item.contains(nonStickySubMenu)) {
            nonStickyHeader.style.height = headerHeight + 48 + "px";
          } 
        });
      }
    });

    nonStickyMenu.addEventListener("mouseleave", (e) => {
      nonStickyHeader.style.height = headerHeight + 48 + "px";
    });

    menuItem.forEach((item) => {
      const subMenuList = item.querySelector(".mega_nav");
      if (screen.width > 1200) {
        item.addEventListener("mouseenter", () => {
          if (item.contains(subMenuList)) {
            headerFixed.style.height = headerHeight + 98 + "px";
          } else if (!item.contains(subMenuList)) {
            headerFixed.style.height = headerHeight + 48 + "px";
          }
        });
        // item.addEventListener("mouseleave", () => {
        //   headerFixed.style.height = headerHeight + 48 + "px";
        // });
      }
    });

    if (screen.width > 1200) {
      headerFixed.addEventListener("mouseenter", () => {
        headerFixed.style.height = headerHeight + 48 + "px";
      });

      headerFixed.addEventListener("mouseleave", () => {
        headerFixed.style.height = headerHeight + "px";
      });
    }
  }

  const mobileMenuBtns = document.querySelectorAll(".mobile_menu_inner");
  const mobileSubmenuLinks = document.querySelectorAll(
    ".mobile_menu_overlay .inner_nav li.sub_menu_link > a"
  );
  if (mobileMenuBtns.length > 0) {
    mobileMenuBtns.forEach((mobileMenuBtn, i) => {
      mobileMenuBtn.addEventListener("click", () => {
        document
          .querySelector(".secondary_navigation")
          .classList.toggle("secondary_navigation--visible");
        document
          .querySelector(".booking-nav")
          .classList.toggle("booking-nav--grey");
        document
          .querySelectorAll(".language_switcher.mobile")[1]
          .classList.toggle("active");
        const headerLogo = document.querySelector(
          ".site_header.non_sticky .icon-logo"
        );
        if (getComputedStyle(headerLogo).fill == "rgb(255, 255, 255)") {
          headerLogo.style.fill = "#000";
        } else {
          headerLogo.style.fill = "";
        }

        const menuOverlay = document.querySelector(".mobile_menu_overlay");
        // if (mobileMenuBtn.closest(".sticky_header") && parseFloat(getComputedStyle(menuOverlay).paddingTop) != document.querySelector(".sticky_header").offsetHeight) {
        //   menuOverlay.style.paddingTop = document.querySelector(".sticky_header").offsetHeight + "px";
        // } else {
        //   menuOverlay.style.paddingTop = "";
        // }

        let menuHeight =
          menuOverlay.querySelector(".inner_nav").offsetHeight +
          parseFloat(getComputedStyle(menuOverlay).paddingTop);

        // if (menuHeight > document.documentElement.clientHeight || document.documentElement.clientWidth < 680) {
        //   menuHeight = document.documentElement.clientHeight;
        // }

        if (menuOverlay.classList.contains("active")) {
          menuOverlay.style.visibility = "visible";
          TweenLite.fromTo(
            menuOverlay,
            0.6,
            { height: 0 },
            { height: menuHeight + "px" }
          );
        } else {
          TweenLite.fromTo(
            menuOverlay,
            0.6,
            { height: menuHeight + "px" },
            {
              height: 0,
              onComplete: () => {
                menuOverlay.style.visibility = "";
              },
            }
          );
        }

        mobileSubmenuLinks.forEach((link, i) => {
          link.parentElement.classList.remove("sub_menu_link--opened");
          link.parentElement.classList.remove("sub_menu_link--moved");
        });
      });
    });
  }

  if (mobileSubmenuLinks.length > 0) {
    mobileSubmenuLinks.forEach((link, i) => {
      link.addEventListener("click", (e) => {
        if (!link.parentElement.classList.contains("sub_menu_link--opened")) {
          e.preventDefault();
          mobileSubmenuLinks.forEach((innerLink, i) => {
            innerLink.parentElement.classList.remove("sub_menu_link--opened");
            innerLink.parentElement.classList.remove("sub_menu_link--moved");
          });

          link.parentElement.classList.add("sub_menu_link--opened");
          setTimeout(() => {
            link.parentElement.classList.add("sub_menu_link--moved");
          }, 10);
        }
      });

      let goBackButton = link
        .closest(".sub_menu_link")
        .querySelector(".go_back_btn");
      if (goBackButton) {
        goBackButton.addEventListener("click", () => {
          link.parentElement.classList.remove("sub_menu_link--moved");
          setTimeout(() => {
            link.parentElement.classList.remove("sub_menu_link--opened");
          }, 400);
        });
      }
    });
  }
};
